import React from "react";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { CustomAutocomplete } from "./AutoComplete";

export const DepartmentsAutoComplete = ({ value, onChange }) => {
  const Departments = useSelector((state) => state.departments.departments);

  return (
    <CustomAutocomplete
    options={Departments}
    getOptionLabel={(option) =>  option.name}
    value={value}
    onChange={onChange}
    label="Select Department"
  />
  );
};
